// Copyright (c) 2019 Deere & Company

import WarrantyStatusModal, {getDefaultState} from '../../../shared/state/warranty-status-modal';
import actions from '../../../action-list';

const toggleWarrantyStatusModal = (state, action) =>
    WarrantyStatusModal.update(state, {
        $merge: {
            isModalOpen: action.isOpen
        }
    });

export default (state = getDefaultState(), action) => {

    switch (action.type) {
    case actions.TOGGLE_CLAIM_MAINTENANCE_PLAN_WARRANTY_STATUS_MODAL:
        return toggleWarrantyStatusModal(state, action);
    default:
        return state;
    }

};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/reducers/warranty-status-modal.js